// src/app/shared/components/nav/nav.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { NavComponent } from './nav.component';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule, // Important! This enables routerLink
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    TranslateModule,
    LanguageSelectorComponent,
    NavComponent
  ],
  exports: [NavComponent]
})
export class NavModule { }
